<template>
  <div class="planuri-tratament patient-history">
    <pacient-header />

    <div>
      <h1>Planuri tratament</h1>

      <ul v-if="plans.length"
          class="treatment-plans"
          cy="planuri-tratament-ul">
        <li v-for="(plan, index) in plans"
            :key="index"
            class="flex relative">
          <div class="left-green-icon-wrapper flex-center">
            <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M30.4292 11.6918L25.0123 14.5068L18.422 17.8619C18.2991 17.9305 18.1607 17.9665 18.0199 17.9665C17.8791 17.9665 17.7407 17.9305 17.6178 17.8619L11.029 14.5068L5.61065 11.6918C5.46361 11.6174 5.34008 11.5037 5.25378 11.3633C5.16748 11.2229 5.1218 11.0613 5.1218 10.8965C5.1218 10.7318 5.16748 10.5702 5.25378 10.4298C5.34008 10.2894 5.46361 10.1757 5.61065 10.1013L17.6358 4.21175C17.755 4.15184 17.8865 4.12064 18.0199 4.12064C18.1533 4.12064 18.2849 4.15184 18.404 4.21175L30.4292 10.1013C30.5762 10.1757 30.6997 10.2894 30.786 10.4298C30.8723 10.5702 30.918 10.7318 30.918 10.8965C30.918 11.0613 30.8723 11.2229 30.786 11.3633C30.6997 11.5037 30.5762 11.6174 30.4292 11.6918Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M11.0275 14.5068L5.61065 17.0922C5.46361 17.1666 5.34008 17.2803 5.25378 17.4207C5.16748 17.5611 5.1218 17.7226 5.1218 17.8874C5.1218 18.0522 5.16748 18.2138 5.25378 18.3542C5.34008 18.4946 5.46361 18.6083 5.61065 18.6827L11.0275 21.4977L17.6178 24.8528C17.7407 24.9214 17.8791 24.9574 18.0199 24.9574C18.1607 24.9574 18.2991 24.9214 18.422 24.8528L25.0108 21.4977L30.4292 18.6842C30.5596 18.6046 30.6673 18.4928 30.7421 18.3596C30.8168 18.2264 30.8561 18.0762 30.8561 17.9234C30.8561 17.7707 30.8168 17.6205 30.7421 17.4873C30.6673 17.3541 30.5596 17.2423 30.4292 17.1627L25.0123 14.5068" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M11.0275 21.4962L5.61065 24.0846C5.46361 24.159 5.34008 24.2727 5.25378 24.4131C5.16748 24.5535 5.1218 24.7151 5.1218 24.8798C5.1218 25.0446 5.16748 25.2062 5.25378 25.3466C5.34008 25.487 5.46361 25.6007 5.61065 25.6751L17.6178 31.7747C17.7407 31.8433 17.8791 31.8793 18.0199 31.8793C18.1607 31.8793 18.2991 31.8433 18.422 31.7747L30.4292 25.6751C30.5596 25.5955 30.6673 25.4838 30.7421 25.3505C30.8168 25.2173 30.8561 25.0671 30.8561 24.9144C30.8561 24.7616 30.8168 24.6114 30.7421 24.4782C30.6673 24.345 30.5596 24.2332 30.4292 24.1536L25.0123 21.4977" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

          <div class="content">
            <h2 class="pointer"
                cy="pt-title-pointer"
                @click="handleViewPT(plan._id)">
              {{ plan.title }}
            </h2>
            <p>
              {{ plan.description }}
            </p>
          </div>

          <div class="side-actions">
            <div class="flex flex-between">
              <i class="pdf-icon" v-html="svg.pdf" style="cursor: pointer;"  @click="handlePdfView(plan._id)"></i>

              <span class="date">
                {{ moment(plan.createdAt).format("DD MMM YYYY") }}
              </span>
            </div>

            <div class="flex flex-between">
              <div class="flex align-center">
                <i v-html="svg.euro" />
                <span class="mleft10px">
                  0 %
                </span>
              </div>
            </div>

            <div class="flex">
              <i class="m-left-auto pointer"
                 v-html="svg.handCash"
                 @click="showPaymentBox" />
            </div>
          </div>

          <div v-show="isPaymentBoxVisible"
               class="payments-wrapper absolute">
            <i v-html="svg.closeSimpleX"
               class="close-icon absolute pointer"
               @click="hidePaymentBox" />

            <h2 class="mbott15px">
              Încasare nouă
            </h2>

            <div>
              <BaseInput name="amount"
                         no-label
                         placeholder="suma"
                         :value="payment.amount"
                         @input="handlePayment" />

            </div>

            <div class="mtop15px">
              <BaseInput name="details"
                         no-label
                         type="textarea"
                         placeholder="detalii"
                         :value="payment.details"
                         @input="handlePayment" />
            </div>

            <div class="actions flex mtop15px">
              <button class="save-btn m-left-auto"
                      @click="handleSavePayment(plan)">
                Salveaza
              </button>
            </div>

            <div class="info mtop15px">
              <p v-if="plan.payments.length" class="flex flex-wrap">
                <span>
                  Ultima incasare: {{ moment(plan.payments[plan.payments.length - 1].createdAt).format("DD MMM YYYY")}}
                </span>
                <span>
                  Total incasari la zi: {{ totalIncasariLaZi(plan) }} RON
                </span>
                <span>
                  Total plan de tratament initial: {{ totalPlanInitial(plan) }} RON
                </span>
<!--                <span>-->
<!--                  Total plan de tratament inclusiv modificari: {{ }}-->
<!--                </span>-->
<!--                <span>-->
<!--                  Total tratamente realizate: {{ plan.stages.reduce((total,treatments) => total + treatments.reduce((tt,treatment)=> treatment.completed ? tt + treatment.price : tt, 0), 0) }} RON-->
<!--                </span>-->
                <BaseDropdown
                  name="payment"
                  placeholder="Istoric încasări"
                  :data="paymentHistory(plan)"
                />
              </p>
            </div>
          </div>
        </li>
      </ul>

      <p v-else
         class="no-plans-message"
         cy="no-plans-msg">
        Nu exista planuri de tratament pentru acest pacient.
      </p>
    </div>

    <footer>
      <ul>
        <li>
          <button class="noborder bg-transparent pointer"
                  @click="handleNewPlan"
                  cy="new-treatment-plan">
            <svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg">
<!--              <circle cx="27.5" cy="27.5" r="27.5" fill="#9A4ECD"/>-->
              <rect id="Oval" fill="#9A4ECD" x="0" y="0" width="52" height="52" rx="4" ry="4"></rect>
              <
              <g opacity="0.7">
                <path d="M45.6484 23.0953L41.4368 25.284L36.3128 27.8926C36.2172 27.946 36.1096 27.974 36.0001 27.974C35.8906 27.974 35.783 27.946 35.6874 27.8926L30.5646 25.284L26.3518 23.0953C26.2374 23.0374 26.1414 22.949 26.0743 22.8399C26.0072 22.7307 25.9717 22.6051 25.9717 22.477C25.9717 22.3488 26.0072 22.2232 26.0743 22.1141C26.1414 22.0049 26.2374 21.9165 26.3518 21.8586L35.7014 17.2795C35.7941 17.2329 35.8964 17.2086 36.0001 17.2086C36.1038 17.2086 36.2061 17.2329 36.2988 17.2795L45.6484 21.8586C45.7628 21.9165 45.8588 22.0049 45.9259 22.1141C45.993 22.2232 46.0285 22.3488 46.0285 22.477C46.0285 22.6051 45.993 22.7307 45.9259 22.8399C45.8588 22.949 45.7628 23.0374 45.6484 23.0953Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M30.5634 25.2839L26.3518 27.2941C26.2374 27.352 26.1414 27.4404 26.0743 27.5495C26.0072 27.6587 25.9717 27.7843 25.9717 27.9124C25.9717 28.0406 26.0072 28.1662 26.0743 28.2753C26.1414 28.3845 26.2374 28.4729 26.3518 28.5308L30.5634 30.7194L35.6874 33.3281C35.783 33.3814 35.8906 33.4094 36.0001 33.4094C36.1096 33.4094 36.2172 33.3814 36.3128 33.3281L41.4356 30.7194L45.6484 28.5319C45.7498 28.4701 45.8336 28.3831 45.8917 28.2796C45.9498 28.176 45.9804 28.0592 45.9804 27.9404C45.9804 27.8217 45.9498 27.7049 45.8917 27.6013C45.8336 27.4977 45.7498 27.4108 45.6484 27.3489L41.4368 25.2839" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M30.5634 30.7183L26.3518 32.7308C26.2374 32.7886 26.1414 32.877 26.0743 32.9862C26.0072 33.0953 25.9717 33.221 25.9717 33.3491C25.9717 33.4772 26.0072 33.6028 26.0743 33.712C26.1414 33.8212 26.2374 33.9096 26.3518 33.9674L35.6874 38.7099C35.783 38.7633 35.8906 38.7913 36.0001 38.7913C36.1096 38.7913 36.2172 38.7633 36.3128 38.7099L45.6484 33.9674C45.7498 33.9055 45.8336 33.8186 45.8917 33.7151C45.9498 33.6115 45.9804 33.4947 45.9804 33.3759C45.9804 33.2572 45.9498 33.1404 45.8917 33.0368C45.8336 32.9332 45.7498 32.8463 45.6484 32.7844L41.4368 30.7194" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <path d="M14 29H9C8.71667 29 8.47934 28.904 8.288 28.712C8.09667 28.52 8.00067 28.2827 8 28C7.99934 27.7173 8.09534 27.48 8.288 27.288C8.48067 27.096 8.718 27 9 27H14V22C14 21.7167 14.096 21.4793 14.288 21.288C14.48 21.0967 14.7173 21.0007 15 21C15.2827 20.9993 15.5203 21.0953 15.713 21.288C15.9057 21.4807 16.0013 21.718 16 22V27H21C21.2833 27 21.521 27.096 21.713 27.288C21.905 27.48 22.0007 27.7173 22 28C21.9993 28.2827 21.9033 28.5203 21.712 28.713C21.5207 28.9057 21.2833 29.0013 21 29H16V34C16 34.2833 15.904 34.521 15.712 34.713C15.52 34.905 15.2827 35.0007 15 35C14.7173 34.9993 14.48 34.9033 14.288 34.712C14.096 34.5207 14 34.2833 14 34V29Z" fill="white"/>
            </svg>
          </button>
        </li>
      </ul>
    </footer>
  </div>
</template>

<script>
  import moment from 'moment';
  import {svg} from '@/store/svg';
  import BaseInput from '@/components/BaseInput.vue';

  export default {
    name: 'PlanTratament',
    components: { BaseInput },
    data () {
      return {
        moment,
        isPaymentBoxVisible: false,
        payment: {
          amount: '',
          details: ''
        },
        activePaymentBox: undefined
      }
    },
    created () {
      this.$store.dispatch('get_planuri_tratament');
    },
    computed: {
      svg () {
        return svg
      },
      plans () {
        return this.$store.state.pt.plans;
      },
      totalIncasariLaZi () {
        return (plan) => plan.payments.reduce((total, pay) => total + Number(pay.amount || 0), 0);
      },
      totalPlanInitial () {
        return plan =>
          plan?.stages?.flatMap(s => s.treatments || [])
            .reduce((sum, t) => sum + (Number(t.price) || 0) * (Number(t.quantity) || 1), 0) || 0;
      },
      paymentHistory () {
        return (plan) => plan.payments.map( o =>  moment(o.createdAt).format('DD MMM YYYY') + ' ' + o.amount + ' ' + o.details);
      }

    },
    methods: {
      handleNewPlan () {
        this.$store.commit('RESET_NEW_PLAN');
        this.$router.push(`new/${this.$router.currentRoute.params.id}`);
      },
      handlePdfView (id) {
        this.$store.commit('RESET_USER');
        this.$router.push(`/plan-tratament/${id}`);
      },
      handleViewPT (id) {
        const idPacient = this.$route.params.id;
        this.$router.push(`/pacienti/plan-tratament/${id}/${idPacient}`);
      },
      handlePayment ({ name, value }) {
        this.payment[name] = value;
      },
      handleSavePayment (plan) {
        this.$store.dispatch('save_payment', {
          _id: plan._id,
          payment: this.payment,
          clbk: this.hidePaymentBox
        });
      },
      showPaymentBox (ev) {
        this.activePaymentBox = ev.target.closest('div').parentElement.parentElement.lastElementChild;
        this.activePaymentBox.style.display = 'block';
      },
      hidePaymentBox () {
        this.payment = {
          amount: '',
          details: ''
        }
        this.activePaymentBox.style.display = 'none';
      }
    }
  }
</script>

<style lang="less">
  .planuri-tratament {
    @media only screen and (min-width: 0) {
      --light-blue: #ECF6FE;
      min-height: 20px;
      margin-bottom: 20px;
      h1 {
        margin-top: 24px;
        opacity: 0.7;
        font-size: 2.8rem;
      }

      .treatment-plans {
        margin-top: 24px;
        li {
          margin-bottom: 24px;
          border-radius: 8px;
          border: 1px solid #CDCDCD;
          position: relative;
          h2 {
            font-size: 1.9rem;
          }
          p {
            margin-top: 8px;
            font-size: 1.5rem;
            line-height: 1.4;
          }

          > div:first-child {
            width: 58px;
            background-color: #1EB386;
            opacity: 0.4;
            border-bottom-left-radius: 8px;
            border-top-left-radius: 8px;
          }

          div.content {
            padding: 16px 24px;
            //flex: 1 0 auto;
          }

          .side-actions {
            flex: 1 0 auto;
            padding: 4px 8px;
            span {
              font-size: 1.4rem;
            }
            .pdf-icon {
              margin-right: 8px;
              transform: scale(0.8);
            }
            .date {
              padding-top: 6px;
            }
          }

          .payments-wrapper {
            width: 400px;
            padding: 24px;
            right: 20px;
            top: 80px;
            z-index: 999;
            border: 1px solid #AAAAAA;
            background-color: var(--light-blue);
            border-radius: 6px;
            .close-icon {
              top: 10px;
              right: 10px;
            }
            textarea {
              width: 100%;
            }
          }
        }
      }
      .no-plans-message {
        margin-top: 16px;
        font-size: 1.6rem;
      }
    }
  }
</style>
